// Shared with the application resource selector: Standard is CU-based,
// Azure is Elastic, and other provider tabs are Integrations.
export const standardResourceSizes = [
    { id: 1, cpu: 1, memory: 4 },
    { id: 2, cpu: 2, memory: 8 },
    { id: 3, cpu: 4, memory: 16 },
    { id: 4, cpu: 8, memory: 32 },
    { id: 5, cpu: 12, memory: 48 },
    { id: 6, cpu: 16, memory: 64 }
]

export function resourceCloudTabs(nodePools) {
    const clouds = (Array.isArray(nodePools) ? nodePools : []).map(item => item.cloud).filter(Boolean)
    return [...new Set(clouds)].sort((first, second) => Number(second === 'azure') - Number(first === 'azure'))
}

export function resourceProviderLabel(cloud) {
    if (cloud === 'switch') return 'Switch Cloud'
    if (cloud === 'azure') return 'Azure'
    return cloud
}

export function resourceOptimization(nodePool) {
    if (!nodePool) return null
    if (nodePool.ssd || nodePool.limits?.ssd) return 'ssd'
    if (nodePool.gpu_type || nodePool.type === 'gpu') return 'gpu'
    return 'cpu'
}
